import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const avaliaDxHubCustomizationPlugin = createPlugin({
  id: 'avalia-dx-hub-customization',
  routes: {
    root: rootRouteRef,
  },
});

export const AvaliaDxHubRouter = avaliaDxHubCustomizationPlugin.provide(
  createRoutableExtension({
    name: 'AvaliaDxHubRouter',
    component: () =>
      import('./pages/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);


